import { getIntl } from "client/utils/internationalization";

import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { I18nValues, MerchantField } from "../../types";
import { fileUploadS3TestValue } from "../../utils/constants";

export class CertifiedGovIdSecondaryField extends Field<string> {
  protected readonly _owner: BusinessOwner;

  constructor(
    model: Merchant,
    owner: BusinessOwner,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: fileUploadS3TestValue,
      propertyName: "certifiedGovIdSecondary",
      uiFieldType: "FileUpload",
      ...opts,
    });

    this._owner = owner;
  }
  get i18nValues(): I18nValues {
    const country = this._model.companyInformation.registeredCountry.value;

    const verificationMethod = this._owner.verificationMethod.value;

    let label = "";
    if (verificationMethod === "Certified Passport") {
      label = "currentPassport_Secondary";
    } else if (verificationMethod === "Licence Birth Certificate") {
      label = "licenceBirthCertificate_Secondary";
    } else if (verificationMethod === "Licence Document") {
      label = "licenceDocument_Secondary";
    }

    const t = getIntl(country);
    return {
      label: t(label),
    };
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    const verificationMethod = this._owner.verificationMethod.value;

    const { requireCertifiedId } = this._owner.controlValues;

    if (
      registeredCountry === "New Zealand" &&
      requireCertifiedId &&
      (verificationMethod === "Licence Birth Certificate" ||
        verificationMethod === "Licence Document")
    ) {
      return true;
    }

    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get uploadFilename(): string {
    const firstName = this._owner.firstName.value;
    const lastName = this._owner.lastName.value;
    return `${firstName}_${lastName}_${this.propertyName}`;
  }
}
